import { Header } from '@/components/layout/Header';
import { Footer } from '@/components/sections/Footer';
import { SEO } from '@/components/SEO';
import { useTranslation } from 'react-i18next';

const Palme = () => {
  const { t } = useTranslation(['palme', 'seo']);

  const reservationStructuredData = {
    '@context': 'https://schema.org',
    '@type': 'ReservationAction',
    target: { '@type': 'Restaurant', name: 'Brace e Sapori' },
  };

  return (
    <main id="main-content" className="min-h-screen bg-background">
      <SEO
        title={t('seo:palme.title')}
        description={t('seo:palme.description')}
        keywords={t('seo:palme.keywords')}
        logicalPath="/palme"
        structuredData={reservationStructuredData}
      />
      <Header />
      <section className="py-32 px-6">
        <div className="mx-auto max-w-4xl">
          <div className="mb-8 text-center">
            <h1 className="mb-4 text-4xl font-semibold text-foreground md:text-5xl">{t('palme:title')}</h1>
            <p className="text-muted-foreground">{t('palme:subtitle')}</p>
          </div>
          <div className="relative w-full overflow-hidden rounded-lg border border-border bg-card">
            <iframe
              src="https://pnssm.pro/pln7wi0"
              className="h-[1500px] md:h-[1500px] w-full border-0"
              title={t('palme:iframeTitle')}
              allow="clipboard-write"
              loading="lazy"
            />
          </div>
        </div>
      </section>
      <Footer />
    </main>
  );
};

export default Palme;
